import { render, staticRenderFns } from "./notification-rule-activity.vue?vue&type=template&id=71690a4d&scoped=true"
import script from "./notification-rule-activity.vue?vue&type=script&setup=true&lang=js"
export * from "./notification-rule-activity.vue?vue&type=script&setup=true&lang=js"
import style0 from "./notification-rule-activity.vue?vue&type=style&index=0&id=71690a4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71690a4d",
  null
  
)

export default component.exports